<mat-card>
  <div style="display: flex; flex-direction: column">
    <div style="display: flex; flex-direction: row; justify-content: stretch;">
      <!-- DND version -->
      <!-- <span class="header-drag-span" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" 
        (cdkDragStarted)="dragStarted($event)" 
        (cdkDragEnded)="dragEnded($event)">
      </span> -->
      
      <span class="header-button-span">
        <button class="header-button" mat-icon-button (click)="onExpandClick()">
          <mat-icon class="header-button-icon" *ngIf="expanded; else elseBlock">arrow_drop_up</mat-icon>
          <ng-template #elseBlock><mat-icon class="header-button-icon">arrow_drop_down</mat-icon></ng-template>
        </button>
      </span>
    </div>
    <div *ngIf="expanded">
      <div class="button-div">
        <button #freeDrawButton mat-icon-button [matTooltip]="'MAP.FREE_DRAWING' | translate" matTooltipPosition="after" matTooltipShowDelay="2000" 
          (click)="onFreeDrawClick()">
          <mat-icon class="svg-icon" svgIcon="free-drawing"></mat-icon>
        </button>
      </div>
      <div class="button-div">
        <button mat-icon-button [matTooltip]="'MAP.RULER' | translate" matTooltipPosition="after" matTooltipShowDelay="2000" [disabled]="isRulerDisabled()"
          (click)="onRulerClick()">
          <mat-icon [ngClass]="isRulerActive() ? 'svg-icon-selected' : (isRulerDisabled() ? 'svg-icon-disabled' : 'svg-icon')" svgIcon="ruler"></mat-icon>
        </button>
      </div>
      <div class="button-div">
        <button mat-icon-button [matTooltip]="'MAP.HOME' | translate" matTooltipPosition="after" matTooltipShowDelay="2000"
          (click)="onHomeClick()" (contextmenu)="onHomeContextMenu($event)">
          <mat-icon class="svg-icon" svgIcon="home"></mat-icon>
          <span [matMenuTriggerFor]="homeContextMenu"></span>
        </button>
        <mat-menu #homeContextMenu="matMenu">
          <button mat-menu-item (click)="onHomeSet()">{{'MENUBAR.SET_AS_HOME' | translate}}</button>
        </mat-menu>
      </div>
      <div class="button-div">
        <button #jumpToButton mat-icon-button [matTooltip]="'MAP.JUMP_TO' | translate" matTooltipPosition="after" matTooltipShowDelay="2000" [disabled]="isJumpToActive()"
          (click)="onJumpToClick()">
          <mat-icon [ngClass]="isJumpToActive() ? 'svg-icon-disabled' : 'svg-icon'" svgIcon="jump-to"></mat-icon>
        </button>
      </div>
      <!-- <div class="button-div">
        <button mat-icon-button matTooltip="Bull’s Eye" matTooltipPosition="after" matTooltipShowDelay="2000" [disabled]="isBullsEyeDisabled()"
          (click)="onBullsEyeClick()">
          <mat-icon [ngClass]="isBullsEyeActive() ? 'svg-icon-selected' : (isBullsEyeDisabled() ? 'svg-icon-disabled' : 'svg-icon')" svgIcon="bulls-eye"></mat-icon>
        </button>
      </div> -->
      <div class="button-div">
        <button mat-icon-button [matTooltip]="'MAP.SECONDARY_MAP' | translate" matTooltipPosition="after" matTooltipShowDelay="2000" [disabled]="isSecondaryMapDisabled()"
          (click)="onSecondaryMapClick()">
          <mat-icon [ngClass]="isSecondaryMapDisabled() ? 'svg-icon-disabled' : 'svg-icon'" svgIcon="second-map"></mat-icon>
      </button>
      </div>
      <div class="button-div">
        <button #mapButton mat-icon-button [matTooltip]="'MAP.MAP_TYPES' | translate" matTooltipPosition="after" matTooltipShowDelay="2000" (click)="onMapClick()">
          <mat-icon class="svg-icon" svgIcon="map"></mat-icon>
        </button>
      </div>
    </div>
  </div>
</mat-card>

